import { createContext } from 'react';
import noop from 'lodash/noop';

import toursApi from '../api';
import { Tour } from '../types';
import { ModelOptions } from '../../../types';

type ApiFuncContext = Pick<
    typeof toursApi,
    'query' | 'duplicateManyByFromDate' | 'getPartialFormat' | 'post'
>;

export interface ToursContext extends ApiFuncContext {
    get: (params?: Partial<Tour>, options?: ModelOptions, updateState?: boolean) => Promise<Array<Tour>>;
    getOne: (
        params: Partial<Tour>,
        body?: { populateQuery?: Array<any>; projection?: any; preventPopulate: boolean }
    ) => Promise<Tour>;
    put: (body: Partial<Tour>) => Promise<Tour>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: number | string }) => Promise<any>;
    data: Tour[];
    setData: (array: Array<Tour>) => void;
    selected: Tour | null;
    setSelected: (object: Tour) => void;
    error?: Tour | null | {};
}

const toursContext = createContext<ToursContext>({
    get: toursApi.get,
    getOne: toursApi.getOne,
    post: toursApi.post,
    put: toursApi.put,
    remove: toursApi.remove,
    softDelete: toursApi.softDelete,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    error: null,
    duplicateManyByFromDate: toursApi.duplicateManyByFromDate,
    query: toursApi.query,
    getPartialFormat: toursApi.getPartialFormat
});
export default toursContext;
